import { NavigationDtoResponse } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { portalGatewayClient } from '../portalGatewayClient';

export const fetchNavigation: QueryFunction<
  NavigationDtoResponse
> = async () => {
  try {
    const response = await portalGatewayClient.navigation.getNavigation();
    const res = response.data;
    return res;
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
